export interface Volume {
  icon: string
  number: string
  title: string
  subtitle: string
  problem: string
  bullets: string[]
  result: string
  popular?: boolean
}

export const volumes: Volume[] = [
  {
    icon: '📘',
    number: 'Volume 1',
    title: 'Fondamenti della Ricerca Scientifica',
    subtitle:
      'La base di cui i tuoi studenti hanno bisogno per comprendere tutto il resto',
    problem:
      'Il primo incontro con la metodologia della ricerca può essere stimolante oppure trasformarsi rapidamente in una serie di definizioni difficili da memorizzare. Questo volume costruisce le fondamenta in modo progressivo e comprensibile.',
    bullets: [
      'Che cos’è la ricerca scientifica',
      'Dal tema al problema di ricerca',
      'Delimitazione del problema',
      'Formulazione delle domande di ricerca',
      'Obiettivo generale e obiettivi specifici',
      'Coerenza tra problema, domanda e obiettivi',
      'Fattibilità e rilevanza',
      'Casi, attività e mini-progetti',
    ],
    result:
      'I tuoi studenti comprendono la ricerca come un processo logico e organizzato, non come un insieme di termini astratti da memorizzare.',
  },
  {
    icon: '📗',
    number: 'Volume 2',
    title: 'Obiettivi, Ipotesi, Variabili e Disegno della Ricerca',
    subtitle:
      'Il passaggio dalla domanda alla costruzione di una ricerca metodologicamente solida',
    problem:
      'È uno dei punti in cui gli studenti iniziano più facilmente a confondersi. Questo volume mostra come trasformare una domanda di ricerca in decisioni metodologiche coerenti.',
    bullets: [
      'Obiettivo generale e obiettivi specifici',
      'Costruzione delle ipotesi',
      'Tipologie di ipotesi',
      'Variabili indipendenti e dipendenti',
      'Variabili di controllo e confondenti',
      'Moderatori e mediatori',
      'Operazionalizzazione',
      'Indicatori e misure',
      'Disegni sperimentali e non sperimentali',
      'Validità interna ed esterna',
    ],
    result:
      'I tuoi studenti imparano a collegare Domanda → Obiettivi → Ipotesi → Variabili → Disegno, senza costruire progetti incoerenti.',
  },
  {
    icon: '📙',
    number: 'Volume 3',
    title: 'Metodi Quantitativi, Qualitativi e Misti',
    subtitle:
      'Come insegnare a scegliere il metodo corretto in funzione della domanda di ricerca',
    problem:
      'Quantitativo? Qualitativo? Metodi misti? Per molti studenti sono etichette che sembrano chiare finché non devono realmente scegliere quale utilizzare. Questo volume insegna a prendere quella decisione con criterio.',
    bullets: [
      'Ricerca quantitativa',
      'Ricerca qualitativa',
      'Dati e misurazione',
      'Studio di caso',
      'Fenomenologia',
      'Etnografia',
      'Grounded theory',
      'Ricerca narrativa',
      'Codifica qualitativa',
      'Categorie e temi',
      'Triangolazione',
      'Mixed methods',
      'Disegni convergenti e sequenziali',
      'Integrazione delle evidenze',
    ],
    result:
      'Gli studenti smettono di scegliere il metodo “perché sembra più facile” e imparano a scegliere quello realmente coerente con il proprio problema.',
    popular: true,
  },
  {
    icon: '📕',
    number: 'Volume 4',
    title: 'Campionamento, Tecniche e Strumenti di Raccolta dei Dati',
    subtitle:
      'Insegna a raccogliere informazioni in modo metodologicamente corretto',
    problem:
      'Uno degli aspetti più pratici della ricerca. Questo volume mostra agli studenti chi osservare, come selezionarlo e quali strumenti utilizzare per ottenere dati utili.',
    bullets: [
      'Popolazione e campione',
      'Unità di analisi',
      'Campionamento probabilistico',
      'Campionamento non probabilistico',
      'Dimensione del campione',
      'Bias',
      'Questionari',
      'Scale',
      'Interviste',
      'Focus group',
      'Osservazione',
      'Validità e affidabilità',
      'Pilot test',
      'Piano di raccolta dati',
    ],
    result:
      'Gli studenti comprendono che raccogliere dati non significa semplicemente creare un questionario, ma costruire un processo coerente e controllato.',
  },
  {
    icon: '📓',
    number: 'Volume 5',
    title: 'Analisi, Interpretazione e Presentazione dei Risultati',
    subtitle:
      'Trasforma i dati in evidenze e conclusioni realmente difendibili',
    problem:
      'Molti studenti arrivano alla fine della raccolta dati senza sapere cosa fare con ciò che hanno ottenuto. Questo volume insegna a trasformare i dati in risultati comprensibili.',
    bullets: [
      'Pulizia dei dati',
      'Frequenze e percentuali',
      'Media e mediana',
      'Variabilità',
      'Tabelle e grafici',
      'Confronto tra gruppi',
      'Correlazione e causalità',
      'Significatività statistica',
      'Rilevanza pratica',
      'Analisi qualitativa',
      'Codici, categorie e temi',
      'Mixed methods',
      'Risultati e discussione',
      'Limiti e conclusioni',
    ],
    result:
      'Gli studenti imparano a interpretare ciò che i dati mostrano realmente, senza arrivare a conclusioni che le evidenze non possono sostenere.',
  },
  {
    icon: '📔',
    number: 'Volume 6',
    title: 'Ricerca Bibliografica, Scrittura Accademica e Progetto Finale',
    subtitle: 'Il volume che chiude l’intero percorso di ricerca',
    problem:
      'Una ricerca può essere metodologicamente corretta e comunque risultare debole se lo studente non sa cercare fonti, organizzare la letteratura o comunicare ciò che ha fatto. Questo volume completa il percorso.',
    bullets: [
      'Ricerca bibliografica',
      'Parole chiave e operatori booleani',
      'Valutazione delle fonti',
      'Lettura critica degli articoli',
      'Revisione della letteratura',
      'Matrice della letteratura',
      'Parafrasi',
      'Citazioni e riferimenti',
      'Scrittura accademica',
      'Introduzione e metodo',
      'Risultati e discussione',
      'Abstract',
      'Presentazione orale e preparazione alla difesa',
      'Progetto finale completo',
    ],
    result:
      'Gli studenti arrivano alla fine del percorso con una ricerca che possono scrivere, presentare e difendere con maggiore sicurezza metodologica.',
  },
]
